import MapLayerMobile from './component'

export default MapLayerMobile
